<template lang="pug">
  header(:class="{ 'mb' : screenSize.width <= breakpoint }")
    transition(name="fade")
      .background(v-if="currentPage != '/'")
    router-link(to="/")
      transition(name="fade")
        .back-btn(v-if="currentPage != '/'")
          img(src="~@/assets/images/back.svg", alt="")
    .menu-btn(v-if="screenSize.width <= breakpoint" @click="toggleMenu")
      img(src="~@/assets/images/menu.svg", alt="")
    .btn-list(:class="{ 'open' : isOpen }")
      .close-btn(v-if="screenSize.width <= breakpoint" @click="toggleMenu")
        img(src="~@/assets/images/close.svg", alt="")
      router-link(to="/works" @click.native="toggleMenu")
        .btn
          p works
      router-link(to="/experiments" @click.native="toggleMenu")
        .btn
          p experiments
      router-link(to="/about" @click.native="toggleMenu")
        .btn
          p about
</template>

<script>
export default {
  name: 'Header',
  props: ['screenSize'],
  data () {
    return {
      breakpoint: 600,
      fullWidth: 0,
      fullHeight: 0,
      isOpen: false
    }
  },
  computed: {
    currentPage: function() {
      return this.$route.path;
    }
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    }
  },
  watch: {
    'screenSize.width' (to, from) {
      if(to > this.breakpoint) {
        this.isOpen = false;
      }
    }
  },
}
</script>

<style lang="sass" scoped>
  header
    position: fixed
    z-index: 1000
    width: 100%
    top: 0
    left: 0
    height: 90px
    display: flex
    align-items: center
    justify-content: space-between
    padding: 0 50px 0 30px
    color: #fff
    text-transform: uppercase
    // mix-blend-mode: difference
    .background
      height: 100%
      width: 100%
      position: absolute
      top: 0
      left: 0
      background: linear-gradient(180deg, rgba(#707070,1), rgba(#707070,0))
      // mix-blend-mode: normal
    .back-btn
      padding: 10px
      img
        width: 24px
    .menu-btn
      cursor: pointer
      img
        width: 40px
    .btn-list
      display: flex
      align-items: center
      height: 100%
    a
      color: inherit
      text-decoration: none
    .btn
      flex: 0 0 auto
      display: flex
      align-items: center
      margin: 0 20px
      cursor: pointer
      -webkit-tap-highlight-color:  rgba(255, 255, 255, 0)
      background-color: rgba(#2e2e2e,0)
      translate: 0.2s
      font-size: 20px
      &::before
        content: ""
        display: block
        position: absolute
        width: 0%
        height: 1px
        background-color: #fff
        left: 0
        bottom: -4px
        transition: 0.5s cubic-bezier(0.17, 0.67, 0, 0.9)
      &:hover
        &::before
          width: 100%
    &.mb
      // mix-blend-mode: normal
      // mix-blend-mode: screen
      padding: 0 20px 0 15px
      .close-btn
        position: absolute
        top: 20px
        right: 20px
        padding: 10px
        img
          width: 24px
          filter: invert(100%)
      .btn-list
        position: fixed
        // isolation: isolate
        top: 0
        left: 0
        width: 100%
        height: 100vh
        flex-direction: column
        justify-content: center
        background-color: #000
        transform: translateX(100%)
        transition: transform 0.5s

        background-color: #333

        &.open
          transform: translateX(0%)
        .btn
          font-size: 30px
          margin: 30px
    .router-link-active>.btn
      &::before
        width: 100% !important
</style>






// WEBPACK FOOTER //
// src/components/Header.vue